import React, { useState, useEffect } from 'react';
import { Select, Button, Tooltip, Icon, DatePicker } from 'antd';

import Grid from '@material-ui/core/Grid';
import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
// import FrontContainer from 'app/containers/FrontContainer';
import CommunicationProgramSummaryContainer from 'app/containers/CommunicationProgramKeyUserSummaryContainer';
// import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import { useDispatch, useSelector } from 'react-redux';
// import CommunicationProgramContainer from 'app/containers/CommunicationProgramContainer';
import { EXPORT_CA_REQUEST, EXPORT_CA_SUCCESS, EXPORT_CA_FAILURE } from 'app/actions/CommunicationProgramKeyUserActions';
// import { fetchCommunicationsDispatch, workCycleEvaluationClear } from 'app/actions/WorkCycleActions';
import { fetchCommunicationProgramSummary, clearCommunicationProgramSummary, fetchGraphics, clearGraphics } from 'app/actions/CommunicationProgramKeyUserActions';

import ApiService from 'app/services/ApiService';

import moment from 'moment';

const { Option } = Select;



const SelectItem = (name = [], value) => {
    if (name == null) {
        return <Option disabled key={'cargando'}>Cargando valores..</Option>
    }

    let x = [...new Set(name.map(i => i[value]))];
    x = name.map(i => i[value]);
    return (
        x.map((c, i) => <Option key={i}>{c}</Option>)
    );
}
export default function ComplianceAdvanceForm(props) {
    const classes = props.classes;
    const dispatch = useDispatch();
    const [collapse, setCollapse] = useState(true);
    let [frontList, setFrontList] = useState();
    const [subdir, setSubdir] = useState('');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');

    useEffect(() => {
        (search());
    }, [dispatch])

    const disabledMEndDate = (current) => {
        if (fechaInicio === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) < moment(fechaInicio)) {
                return true;
            } else return false;
        }
    }

    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    const {
        isLoadingCAExport
    } = useSelector(state => state.CommunicationProgram);

    const isOilService = idSubdirection === 3;

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const {
        siteId
    } = useSelector(state => state.Auth);

    const detrmineRolSite = () => {
        //Regla 17.03.2022 Rivera: Si es admin abordo => tipo de capacitacion D.O; Admin Tierra => Sus tipos de capacitacion
        for (const rol of Roles) {
            if (rol.NameRole.includes('Administrador'))
                return siteId;
        }
        return '';
    }

    const data = {
        TrainingId: props.training,
        CommunicationProgramId: props.cp,
        FrontId: props.front,
        RolSite: !props.training.length ? detrmineRolSite() : '',
        EmployeeId: employeeId,
        Limit: props.pagination.pageSize,
        Offset: (0 * props.pagination.pageSize),
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === 'ascend' ? 'ASC' : 'DESC' : '',
        SubdirectionId: idSubdirection/*subdir*/
        , EsSuperAdmin: 0,
    }

    const search = async () => {
        var respnse = IsSuperAdmin();
        data.EsSuperAdmin = respnse ? 1 : 0
        dispatch(clearCommunicationProgramSummary());
        dispatch(clearGraphics());
        dispatch(fetchCommunicationProgramSummary(data));
        dispatch(fetchGraphics(data));
        props.setFormData(data)
    }

    const IsSuperAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Super Administrador')) {
                return true;
            }

        }
        return null;
    }

    const toExport = async () => {

        var respnse = IsSuperAdmin();
        const params = {
            SubdirectionId: idSubdirection,
            FrontId: props.front,
            TrainingId: props.training,
            CommunicationProgramId: props.cp,
            RolSite: !props.training.length ? detrmineRolSite() : '',
            EmployeeId: employeeId,
            EsSuperAdmin: respnse ? 1 : 0,
        }
        dispatch({ type: EXPORT_CA_REQUEST });
        await ApiService.getCommunicationProgramsKeyUserSummaryExport(params)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, 'CumplimientoDeAvanceKeyUser.xlsx');
                    dispatch({ type: EXPORT_CA_SUCCESS });
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    dispatch({ type: EXPORT_CA_FAILURE });
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };
    return (
        <CommunicationProgramSummaryContainer subdirectionId={idSubdirection}>
            {(params) => {
                return (
                    <div>

                        <div className={classes.container} style={props.styles.baseVerticalMargin}>

                            <Button
                                className={classes.button}
                                variant='contained'
                                type='primary'
                                onClick={toExport}
                                loading={isLoadingCAExport}
                            >
                                Exportar
                            </Button>
                        </div>
                    </div>
                )
            }}
        </CommunicationProgramSummaryContainer>
    );

}